// src/theme/colors.ts
export const COLORS = {
  // Основные цвета (оставляем как есть)
  background: '#EFF6EF',
  primary: '#245D33',
  secondary: '#A7ABAA',
  text: '#465357',
  footer: '#212122',
  
  // Статусы клиентов (оставляем как есть)
  clientStatus: {
    cold: {
      bg: 'bg-[#A7ABAA]/20',
      text: 'text-[#465357]'
    },
    new: {
      bg: 'bg-[#245D33]/20',
      text: 'text-[#245D33]'
    },
    rare: {
      bg: 'bg-[#245D33]/30',
      text: 'text-[#245D33]'
    },
    regular: {
      bg: 'bg-[#245D33]/40',
      text: 'text-[#245D33]'
    },
    loyal: {
      bg: 'bg-[#245D33]/60',
      text: 'text-[#245D33]'
    },
    lost: {
      bg: 'bg-[#212122]/20',
      text: 'text-[#B45309]'
    }
  },

  // Цвета для диаграмм статусов клиентов (новый блок)
  clientChartColors: {
    new: '#4A90E2',
    rare: '#50E3C2',
    regular: '#F5A623',
    loyal: '#7ED321',
    lost: '#D0021B',
    cold: '#607D8B',    // Добавляем серый цвет для холодных клиентов
    default: '#245D33'  // Цвет по умолчанию
  },

  // Цвета для диаграмм источников привлечения (новый блок)
  sourceChartColors: {
    organic: '#4CAF50',
    direct: '#2196F3',
    referral: '#FF9800',
    social: '#E91E63',
    whatsapp: '#25D366',
    instagram: '#E1306C',
    telegram: '#0088CC',
    website: '#4285F4',
    default: '#245D33'
  },

  // Нейтральные оттенки (оставляем как есть)
  neutral: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
  },

  // Статусы (оставляем как есть)
  status: {
    success: {
      light: '#dcfce7',
      dark: '#166534',
      bg: 'bg-[#dcfce7]',
      text: 'text-[#166534]'
    },
    warning: {
      light: '#fef9c3',
      dark: '#854d0e',
      bg: 'bg-[#fef9c3]',
      text: 'text-[#854d0e]'
    },
    error: {
      light: '#fee2e2',
      dark: '#991b1b',
      bg: 'bg-[#fee2e2]',
      text: 'text-[#991b1b]'
    },
    info: {
      light: '#dbeafe',
      dark: '#1e40af',
      bg: 'bg-[#dbeafe]',
      text: 'text-[#1e40af]'
    },
    debug: {
      light: '#fef3c7',
      dark: '#92400e',
      bg: 'bg-[#fef3c7]',
      text: 'text-[#92400e]'
    }
  },
  
  // Формы и элементы управления (оставляем как есть)
  form: {
    input: {
      border: '#A7ABAA',
      focus: '#245D33',
      text: '#465357',
      placeholder: '#A7ABAA',
      disabled: '#E2E8F0',
    },
    button: {
      primary: '#245D33',
      primaryHover: '#1e4d2b',
      secondary: '#A7ABAA',
      secondaryHover: '#959998',
    }
  },
  
  // Модальные окна (оставляем как есть)
  modal: {
    overlay: 'rgba(0, 0, 0, 0.4)',
    background: '#FFFFFF',
    border: '#A7ABAA',
  }
} as const;